const IS_PRODUCTION = process.env.ENV === 'production';

export const COLLECTION_CATEGORY_LEVEL = -2;
export const ROOT_CATEGORY_LEVEL = 1;
export const PRIMARY_CATEGORY_LEVEL = 2;
export const SECONDARY_CATEGORY_LEVEL = 3;
export const TERTIARY_CATEGORY_LEVEL = 4;
export const STORIES_LEVEL = 6;
export const BRAND_DETAIL_LEVEL = 7;
export const RECOMMENDED_PRODUCTS_LEVEL = 8;

export const APPLIANCES = '557';
export const COOKWARE_SETS = '141';
export const BAKEWARE = '228';
export const GIFT_CARDS = IS_PRODUCTION ? '22279' : '1094';
export const DRINKWARE = IS_PRODUCTION ? '1407' : '1375';
export const ELECTRONICS_AND_GADGETS = IS_PRODUCTION ? '23097' : '12068';
export const LUGGAGE = IS_PRODUCTION ? '22255' : '11996';
export const AIR_PURIFIERS = '932';
export const VACUUMS = '977';

export const REGISTRY_AWARDS = IS_PRODUCTION ? '1953' : '2720';

export const NUMBER_OF_FEATURED_COLLECTIONS = 3;

export const CATEGORY_PRODUCT_FACETS = {
  CATEGORY_IDS: 'category_ids',
};
